import { useLocation, Navigate } from 'react-router-dom';
import { RoleName } from '@/api/entities/user-role-type';
import { useAuth, useUserRole } from '@/hooks/auth.hooks';
import { useEffect, useState } from 'react';

interface ProtectedRouteProps {
  allowedRoles: RoleName[];
  element: React.ReactNode;
  allowedQueries?: Record<string, string>[];
}

export const RoleProtectedRoute = ({
  allowedRoles,
  element,
  allowedQueries,
}: ProtectedRouteProps) => {
  const { primaryRole } = useAuth();
  const { isAdmin, isModerator } = useUserRole();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem('role') && primaryRole) {
      setIsLoading(false);
    }
  }, [primaryRole]);

  const navigateForUnauthorized = (
    <Navigate
      to={!isAdmin && isModerator ? '/vehicule-checks' : '/dashboard'}
      replace
    />
  );

  if (!isLoading) {
    if (isAdmin) {
      return <>{element}</>;
    }

    if (!allowedRoles?.includes(primaryRole)) {
      return navigateForUnauthorized;
    }

    if (allowedQueries && allowedQueries.length > 0) {
      const hasValidQueryStrings = allowedQueries.some((queryObj) => {
        return Object.entries(queryObj).every(
          ([key, value]) => searchParams.get(key) === value
        );
      });

      if (!hasValidQueryStrings) {
        return navigateForUnauthorized;
      }
    }
  }

  return <>{element}</>;
};
